
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import './styles.scss'
import '../../styles/index.scss'

class SingleInput extends Component {
  componentWillMount () {
    this.previousValue = ''
  }

  setInputField (name, value) {
    const { onChangeValidationFunction = [] } = this.props
    this.props.Store.updateFieldValue(name, value)
    let isValid = true

    onChangeValidationFunction.forEach(funct => {
      if (!funct(name, value)) isValid = false
    })
    this.props.Store.updateFieldError(name, !isValid)
  }

  onChange (name, value) {
    const {
      maxLength = '',
      formatter,
      trimSpaces = false
    } = this.props

    let newValue = value
  
    if (trimSpaces) {
      newValue = newValue.replace(/\s/g, '')
    }
    
    if (maxLength !== '') {
      newValue = newValue.slice(0, maxLength)
    }

    if (formatter) {
      const validLength = newValue.length <= formatter.getBufferLength()
      if (this.previousValue.length < newValue.length && validLength) {
        formatter.format(newValue)
        newValue = formatter.result
      }
      this.previousValue = newValue
      if (validLength) {
        this.setInputField(name, newValue)
      }
    } else {
      this.setInputField(name, newValue)
    }
  }

  onKeyPress (e) {
    const { onKeyPressValidationFunction = [] } = this.props
    onKeyPressValidationFunction.forEach(funct => {
      funct(e)
    })
  }

  render () {
    const {
      title,
      name,
      inputType,
      placeholder,
      overrideId = false,
      id,
      min = '',
      max = '',
      maxLength = '',
      automationName,
      Store
    } = this.props

    const componentError = Store.hasError(name) ? 'error' : ''
    const componentClassNames = `form-control ${componentError}`
    const fieldValue = Store.getValue(name)

    return (
      <div className={`form-group faa-input ${automationName}`}>
        <label className='sr-only' htmlFor={`${name}_ID`}>{title}</label>
        <input
          id={overrideId ? id : `${name}_ID`}
          className={componentClassNames}
          name={name}
          type={inputType}
          value={fieldValue}
          placeholder={placeholder}
          min={min}
          max={max}
          maxLength={maxLength}
          onChange={(e) => { this.onChange(name, e.target.value) }}
          onKeyPress={(e) => { this.onKeyPress(e) }}
          data-automation-name={automationName}
        />
      </div>
    )
  }
}

SingleInput.propTypes = {
  inputType: PropTypes.oneOf(['text', 'number']).isRequired,
  title: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  Store: PropTypes.object.isRequired,
  formatter: PropTypes.object,
  trimSpaces: PropTypes.bool
}

SingleInput.defaultProps = {
  inputType: 'text'
}

export default observer(SingleInput)
